import Http from "../../http/client";

export default async (id, payload) => {
  const response = await Http.put('trip/driver/protectionprice/'+id, payload);
  return response.data;
}
